/**
 * Screen 4 - How soon would you like to achieve your goal?
 */
import classnames from 'classnames';
import isInteger from 'lodash/isInteger';
import React, { PropTypes } from 'react';
import ButtonNext from './ButtonNext';
import ButtonPrevious from './ButtonPrevious';
import QuestionChoice from './QuestionChoice';

function Howsoon({
  nextStep,
  paragraphData,
  previousStep,
  resultHowSoon,
  setResult,
}) {
  const { fieldHowSoonDoYouWantToAc, fieldTitle } = paragraphData;
  const timeTable = fieldHowSoonDoYouWantToAc.map((label, index) =>
    <li key={`question-${index}`}>
      <QuestionChoice
        defaultChecked={resultHowSoon === index}
        index={index}
        label={label.value}
        uuid={paragraphData.uuid[0].value}
        setResult={() => setResult({
          resultHowSoon: index,
          resultHowSoonText: label.value || null,
        })}
      />
    </li>,
  );
  return (
    <div
      className={classnames({
        'goal--step-four': true,
      })}
    >
      <h4
        dangerouslySetInnerHTML={{
          __html: fieldTitle[0] ? fieldTitle[0].value : '',
        }}
      />
      <ul
        className={classnames({
          questions: true,
        })}
      >
        {timeTable}
      </ul>
      <ButtonPrevious
        previousStep={previousStep}
      />
      <ButtonNext
        disabled={!isInteger(resultHowSoon)}
        nextStep={nextStep}
      />
      <div
        style={{
          fontSize: '16px',
          color: '#aaa',
        }}
      >
        Step 4 of 10
      </div>
    </div>
  );
}

Howsoon.propTypes = {
  nextStep: PropTypes.func,
  paragraphData: PropTypes.shape({}),
  previousStep: PropTypes.func,
  resultHowSoon: PropTypes.number,
  setResult: PropTypes.func,
};

export default Howsoon;



// WEBPACK FOOTER //
// js/src/goals/HowSoon.js